import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class Identity implements ViewModel {
  readonly friendlyTypeNameSingular = 'User Details';
  readonly apiRoute: string = CONFIG.apiRoutes.identity;

  userId: string;
  username: string;
  email: string;
  catalog: string;
  usingLoginProvider: boolean;
  passwordResetRequired: boolean;
  isSecurity: boolean;
  isDefaultAdmin: boolean;
  expiresIn: number;
  roles: string[] = [];
  permissions: string[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.userId = data.userId;
    this.username = data.username;
    this.email = data.email;
    this.catalog = data.catalog;
    this.usingLoginProvider = data.usingLoginProvider;
    this.passwordResetRequired = data.passwordResetRequired;
    this.isSecurity = data.isSecurity;
    this.isDefaultAdmin = data.isDefaultAdmin;
    this.expiresIn = data.expiresIn;
    this.roles = data.roles;
    this.permissions = data.permissions;
  }
}
